import { isUndNullEmp } from '../../helpers/main.js';
const currentDateTimeISO = new Date()?.toISOString();

export class Status {
    constructor(
        _id = 0,
        _name = '',
        _label = '',
        _register = currentDateTimeISO,
    ) {
        this.id = _id;
        this.name = _name;
        this.label = _label;
        this.register = _register;
    }

    static getClassName = () => {
        return 'Status - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    //Id: 0,
                    Name: 2,
                    Label: 2,
                    Register: 10,
                },
                max: {
                    //Id: 0,
                    Name: 10,
                    Label: 50,
                    Register: 10,
                }
            };
        } else {
            return {
                min: {
                    //id: 0,
                    name: 2,
                    label: 2,
                    register: 10,
                },
                max: {
                    //id: 0,
                    name: 10,
                    label: 50,
                    register: 10,
                }
            };
        }
    }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName })?.result) {
            if (upperCase) {
                return new Status(
                    obj.Id,
                    obj.Name,
                    obj.Label,
                    obj.Register,
                );
            } else {
                return new Status(
                    obj.id,
                    obj.name,
                    obj.label,
                    obj.register,
                );
            }
        } else {
            return new Status();
        }
    }
}